import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import { EMPTY_ARRAY } from './formatters.js'
import styles from './common.module.css'

export function TimelineBlock({ invitation, activeSection, onSectionClick, mode }: BlockProps) {
  const timeline = invitation.timeline ?? EMPTY_ARRAY

  return (
    <SectionWrapper
      sectionId="timeline"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={styles.section}
    >
      <span className={styles.sectionTitle}>타임라인</span>
      <div className={styles.divider} />
      {timeline.length > 0
        ? timeline.map((item, i) => (
            <div key={i} className={styles.listItem}>
              <p className={styles.listItemTitle}>{item.date ? `${item.date} — ` : ''}{item.title}</p>
              {item.description && <p className={styles.listItemDesc}>{item.description}</p>}
            </div>
          ))
        : <p className={styles.placeholderText}>타임라인이 여기에 표시됩니다</p>
      }
    </SectionWrapper>
  )
}
